// src/components/UserFiles/UserFilesSearchBar.jsx

import React, { useState } from 'react';
import {
  Box,
  TextField,
  IconButton,
  InputAdornment,
  Tooltip,
  Button,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';

const UserFilesSearchBar = ({ t, onSearch, initialQuery = '', loading }) => {
  const [value, setValue] = useState(initialQuery);

  const fireSearch = () => {
    const trimmed = value.trim();
    onSearch(trimmed);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    fireSearch();
  };

  const handleClear = () => {
    setValue('');
    onSearch(''); // reset to normal list
  };

  return (
    <Box
      component="form"
      onSubmit={handleSubmit}
      sx={{
        mb: 2,
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        width: '100%',
      }}
    >
      <TextField
        size="small"
        variant="outlined"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        placeholder={t(
          'files.search_placeholder',
          'Hľadať v názvoch a obsahu súborov...'
        )}
        sx={{ 
          flexGrow: 1, 
          maxWidth: 420,
          '& .MuiOutlinedInput-root': {
            borderRadius: 2,
          }
        }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon fontSize="small" sx={{ color: 'text.secondary' }} />
            </InputAdornment>
          ),
          endAdornment: value ? (
            <InputAdornment position="end">
              <Tooltip title={t('files.search_clear', 'Zrušiť vyhľadávanie')}>
                <IconButton
                  size="small"
                  onClick={handleClear}
                  disabled={loading}
                  sx={{ '&:hover': { color: 'error.main' } }}
                >
                  <ClearIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            </InputAdornment>
          ) : null,
        }}
      />

      {/* SEARCH / FIRE BUTTON */}
      <Button
        variant="contained"
        onClick={fireSearch}
        disabled={loading}
        disableElevation
        sx={{
          borderRadius: 2,
          fontWeight: 600,
          height: 40, // Match the small TextField height perfectly
          px: 3,
          minWidth: 'auto',
        }}
      >
        {t('common.search', 'Hľadať')}
      </Button>
    </Box>
  );
};

export default UserFilesSearchBar;